import type { ExperienceConfiguration } from '@ninetailed/experience.js-shared'

import {
  type ExperienceLike,
  ExperienceMapper
} from '@ninetailed/experience.js-utils'
import { isObject } from '@simplisafe/ewok'

function isReference<T extends { readonly id: string }>(
  a: unknown
): a is ExperienceConfiguration<T> {
  return isObject(a) && typeof a['id'] === 'string'
}

export function safeMapExperiences<
  V extends { readonly id: string },
  U extends { readonly id: string } = { readonly id: string },
  T extends { nt_experiences?: readonly ExperienceLike<U>[] } = {
    readonly nt_experiences?: readonly ExperienceLike<U>[]
  }
>(experiences: T): ExperienceConfiguration<V>[] {
  return (
    experiences.nt_experiences
      ?.map(t => ({ ...t, variants: t.variants ?? [] }))
      .filter(x => ExperienceMapper.isExperienceEntry(x))
      .map(x => ExperienceMapper.mapExperience(x))
      .filter(x => isReference<V>(x)) ?? []
  )
}
